import React from 'react';
import { Info, Shield, Share2, Lock, Scale, RefreshCw, Mail } from 'lucide-react';
import '../../../../styles/components/privacy-policy.scss';
import HeaderBanner from '../../../common/HeaderBanner';
import i18n from '../../../../i18n';

class TermsOfServicePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: 'information-we-collect',
      activeNav: 'Contact',
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  handleSectionClick = (sectionId) => {
    this.setState({ activeSection: sectionId });
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  render() {
    const { activeSection } = this.state;

    const menuItems = [
      { id: 'information-we-collect', label: 'Information We Collect', icon: Info },
      { id: 'how-we-use', label: 'How We Use Your Info', icon: Shield },
      { id: 'data-sharing', label: 'Data Sharing', icon: Share2 },
      { id: 'data-security', label: 'Data Security', icon: Lock },
      { id: 'your-rights', label: 'Your Rights & Choices', icon: Scale },
      { id: 'changes-policy', label: 'Changes to This Policy', icon: RefreshCw },
      { id: 'contact-us', label: 'Contact Us', icon: Mail },
    ];

    return (
      <div className="privacy-page">
        <HeaderBanner
          title={i18n.t('terms_of_service')}
          subtitle={i18n.t('terms_of_service_subtitle')}
        />

        <div className="privacy-container">
          <aside className="privacy-sidebar">
            <nav>
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = activeSection === item.id;
                return (
                  <button
                    key={item.id}
                    onClick={() => this.handleSectionClick(item.id)}
                    className={`sidebar-item ${isActive ? 'active' : ''}`}
                  >
                    <Icon size={20} />
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </nav>
          </aside>

          <main className="privacy-content">
            <div className="update-date">Last Updated: October 26, 2023</div>

            <div className="intro-text">
              Welcome to Mzadcom. We are committed to protecting your privacy. This Privacy Policy
              explains how we collect, use, disclose, and safeguard your information when you visit
              our website and use our auction platform. Please read this privacy policy carefully.
              If you do not agree with the terms of this privacy policy, please do not access the
              site.
            </div>

            <section id="information-we-collect" className="privacy-section">
              <h2>1. Information We Collect</h2>
              <p>
                We may collect information about you in a variety of ways. The information we may
                collect on the Site includes:
              </p>
              <h3>Personal Data</h3>
              <p>
                Personally identifiable information, such as your name, shipping address, email
                address, and telephone number...
              </p>
              <h3>Derivative Data</h3>
              <p>
                Information our servers automatically collect when you access the Site, such as your
                IP address, browser type, operating system, etc.
              </p>
            </section>

            <section id="how-we-use" className="privacy-section">
              <h2>2. How We Use Your Information</h2>
              <ul>
                <li>Create and manage your account.</li>
                <li>Email you regarding your account or order.</li>
                <li>Fulfill and manage purchases, orders, payments, and transactions.</li>
                <li>Increase efficiency and improve the Site.</li>
              </ul>
            </section>

            <section id="data-sharing" className="privacy-section">
              <h2>3. Data Sharing and Disclosure</h2>
              <h3>By Law or to Protect Rights</h3>
              <p>
                If required by law, we may share your information for legal or safety reasons,
                including <span className="highlight">fraud protection</span> and credit risk
                reduction.
              </p>
            </section>

            <section id="data-security" className="privacy-section">
              <h2>4. Data Security</h2>
              <p>
                We use administrative, technical, and physical measures to protect your information,
                but no system is 100% secure.
              </p>
            </section>

            <section id="your-rights" className="privacy-section">
              <h2>5. Your Rights and Choices</h2>
              <p>
                You have rights to access, correct, or delete your data by managing your account
                settings.
              </p>
            </section>

            <section id="changes-policy" className="privacy-section">
              <h2>6. Changes to This Policy</h2>
              <p>
                We may update this policy and will notify you by changing the “Last Updated” date.
              </p>
            </section>

            <section id="contact-us" className="privacy-section">
              <h2>7. Contact Us</h2>
              <div className="contact-box">
                <p>
                  <strong>Mzadcom Auction Platform</strong>
                </p>
                <p>{i18n.t('office_address_info')}</p>
                <p>Email: info@mzadcom.om</p>
              </div>
            </section>
          </main>
        </div>
      </div>
    );
  }
}

export default TermsOfServicePage;
